import { DesignProjectSubtype, ProjectSubtype, ProjectType } from "fond/types";

import { event, oneOf, string } from "../schema-util";

const pageMenuItemClickedEvent = event({
  item: string().describe("The specific menu item that was clicked"),
  projectType: oneOf([...ProjectType, "multi_project"])
    .describe("The type of the project that the menu item belongs to")
    .optional(),
  projectSubType: oneOf([...DesignProjectSubtype, ...ProjectSubtype])
    .describe("The subtype of the project that the menu item belongs to")
    .optional(),
});

export const pageMenu = {
  "page-menu.project.item.clicked": pageMenuItemClickedEvent,
  "page-menu.view.item.clicked": pageMenuItemClickedEvent,
  "page-menu.attachment.item.clicked": pageMenuItemClickedEvent,
  "page-menu.help.item.clicked": pageMenuItemClickedEvent,
};
